module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_01-7b5ac1ff1eed8e15b6793f33ddccb3f9.jpg";